<div class="mep-cockpit">
	<div class="cockpit-body">
		<div class="card-container">
			<!-- Filter -->
			<div class="belonging-container row">
				<div class="col-3">
					@if (!canViewCockpit) {
						<mat-form-field class="lessPadding unit-info">
							<mat-label>{{ "mep.components.homescreen.businessUnit" | translate }}</mat-label>
							<input type="text" matInput disabled [value]="selectedBusinessUnit" />
						</mat-form-field>
					}
					@if (canViewCockpit) {
						<mat-form-field class="lessPadding unit-info">
							<mat-label>{{ "mep.components.homescreen.businessUnit" | translate }}</mat-label>
							<mat-select
								[(ngModel)]="selectedBusinessUnit"
								(ngModelChange)="getDivisionOptions(selectedBusinessUnit, true)"
							>
								@for (businessUnit of businessUnitOptions; track businessUnit) {
									<mat-option [value]="businessUnit.value">{{ businessUnit.viewValue }}</mat-option>
								}
							</mat-select>
						</mat-form-field>
					}
				</div>
				<div class="col-3">
					<mat-form-field class="lessPadding unit-info" [ngClass]="selectedDivision === '' ? 'marked-line' : ''">
						<mat-label>{{ "mep.components.homescreen.division" | translate }}</mat-label>
						<mat-select
							[(ngModel)]="selectedDivision"
							(ngModelChange)="reloadWorkload(selectedDivision, selectedFamilyGroup)"
						>
							@for (division of divisionOptions; track division) {
								<mat-option [value]="division.value">{{ division.viewValue }}</mat-option>
							}
						</mat-select>
					</mat-form-field>
				</div>
				<div class="col-3">
					<mat-form-field class="lessPadding unit-info">
						<mat-label>{{ "mep.components.homescreen.jobFamilies" | translate }}</mat-label>
						<mat-select
							[(ngModel)]="selectedFamilyGroup"
							(ngModelChange)="reloadWorkload(selectedDivision, selectedFamilyGroup)"
						>
							@for (familyGroup of familyGroup; track familyGroup) {
								<mat-option [value]="familyGroup.value">{{ familyGroup.viewValue }}</mat-option>
							}
						</mat-select>
					</mat-form-field>
				</div>
			</div>

			<div class="cockpit-content">
				<div class="mec-card-big">
					<div class="mec-card-header">
						<span class="mec-card-header-text">{{ "mep.components.homescreen.previousMonth" | translate }}</span>
					</div>
					<div class="workload-container">
						<!-- row for mep workload -->
						<div class="workload-information-row row">
							<div class="col-5 text-column">
								<span class="info-text">{{ "mep.components.homescreen.mepWorkload" | translate }}</span>
								<span class="description">{{ "mep.components.homescreen.expectedOperative" | translate }}</span>
							</div>
							<div [ngClass]="noDivision ? 'col-3 no-division' : 'col-1 workload-column'">
								@if (MEPWorkloadPreviousMonth && !loading) {
									<span class="info-text">{{ MEPWorkloadPreviousMonth | number: "1.1-1" : "de" }} %</span>
								}
								@if (!MEPWorkloadPreviousMonth && !loading) {
									<span class="info-text">{{
										"mep.components.homescreen." + (noDivision ? "noDivision" : "noWorkload") | translate
									}}</span>
								}
								@if (loading && !noDivision) {
									<mat-progress-spinner class="spinner" mode="indeterminate"></mat-progress-spinner>
								}
							</div>
							@if (!noDivision) {
								<div class="col-2">
									<app-traffic-light-mec-mep
										[selectedFamilyGroup]="selectedFamilyGroup"
										[workload]="MEPWorkloadPreviousMonth"
									></app-traffic-light-mec-mep>
								</div>
							}
							@if (!noDivision) {
								<div class="col-2 info-column">
									<mat-icon
										class="info"
										matTooltip="{{ 'mep.components.homescreen.legend' | translate }}"
										matTooltipClass="custom-tooltip"
										>info</mat-icon
									>
								</div>
							}
						</div>
						<!-- row for mec workload of selected division -->
						@if (hasValidMecData) {
							<div class="workload-information-row row">
								<div class="col-5 text-column">
									<span
										class="info-text"
										[matTooltip]="'mep.components.homescreen.mecTooltip' | translate"
										[matTooltipPosition]="tooltipPosition.value"
										><a href="https://msg-systems-5.eu10.hcs.cloud.sap/">{{
											"mep.components.homescreen.mecWorkload" | translate
										}}</a></span
									>
									<span class="primary-text">{{ this.selectedDivisionLabel }}</span>
								</div>
								<div [ngClass]="noDivision ? 'col-3 no-division' : 'col-1 workload-column'">
									@if (MECWorkload && !loading) {
										<span class="info-text">{{ MECWorkload | number: "1.1-1" : "de" }} %</span>
									}
									@if (!MECWorkload && !loading) {
										<span class="info-text">{{
											"mep.components.homescreen." + (noDivision ? "noDivision" : "noWorkload") | translate
										}}</span>
									}
									@if (loading && !noDivision) {
										<mat-spinner class="spinner" mode="indeterminate"></mat-spinner>
									}
								</div>
								@if (!noDivision) {
									<div class="col-2">
										<app-traffic-light-mec-mep
											[selectedFamilyGroup]="selectedFamilyGroup"
											[workload]="MECWorkload"
										></app-traffic-light-mec-mep>
									</div>
								}
							</div>
						}
						<!-- row for booking quality -->
						<div class="workload-information-row row">
							<div class="col-5 text-column">
								<span class="info-text">{{ "mep.components.homescreen.bookingQuality" | translate }}</span>
							</div>
							<div [ngClass]="noDivision ? 'col-3 no-division' : 'col-1 workload-column'">
								@if (MECQuality && !loading) {
									<span class="info-text">{{ MECQuality | number: "1.1-1" : "de" }} %</span>
								}
								@if (!MECQuality && !loading) {
									<span class="info-text">{{
										"mep.components.homescreen." + (noDivision ? "noDivision" : "noWorkload") | translate
									}}</span>
								}
								@if (loading) {
									<mat-progress-spinner class="spinner" mode="indeterminate"></mat-progress-spinner>
								}
							</div>
						</div>
					</div>
					@if (!hasValidMecData) {
						<div>
							<div class="workload-information-row row">
								<div class="col-9 textColumn">
									<span class="infoTextNotAvailable">{{
										"mep.components.homescreen.mecNotValidated" | translate
									}}</span>
								</div>
							</div>
						</div>
					}
				</div>
				<div class="mec-card">
					<div class="mec-card-header">
						<span class="mec-card-header-text">{{ "mep.components.homescreen.currentMonth" | translate }}</span>
					</div>
					<!-- row for mep workload expected & operative -->
					<div class="workload-container">
						<div class="workload-information-row row">
							<div class="col-5 text-column">
								<span class="info-text">{{ "mep.components.homescreen.mepWorkload" | translate }}</span>
								<span class="description">{{ "mep.components.homescreen.expectedOperative" | translate }}</span>
							</div>
							<div [ngClass]="noDivision ? 'col-3 no-division' : 'col-1 workload-column'">
								@if (MEPWorkloadCMEO && !loading) {
									<span class="info-text">{{ MEPWorkloadCMEO | number: "1.1-1" : "de" }} %</span>
								}
								@if (!MEPWorkloadCMEO && !loading) {
									<span class="info-text">{{
										"mep.components.homescreen." + (noDivision ? "noDivision" : "noWorkload") | translate
									}}</span>
								}
								@if (loading && !noDivision) {
									<mat-progress-spinner class="spinner" mode="indeterminate"></mat-progress-spinner>
								}
							</div>
							@if (!noDivision) {
								<div class="col-2">
									<app-traffic-light-mec-mep
										[selectedFamilyGroup]="selectedFamilyGroup"
										[workload]="MEPWorkloadCMEO"
									></app-traffic-light-mec-mep>
								</div>
							}
						</div>
						<!-- row for mep workload save & operative -->
						<div class="workload-information-row row">
							<div class="col-5 text-column">
								<span class="info-text">{{ "mep.components.homescreen.mepWorkload" | translate }}</span>
								<span class="description">{{ "mep.components.homescreen.safeOperative" | translate }}</span>
							</div>
							<div [ngClass]="noDivision ? 'col-3 no-division' : 'col-1 workload-column'">
								@if (MEPWorkloadCMSO && !loading) {
									<span class="info-text">{{ MEPWorkloadCMSO | number: "1.1-1" : "de" }} %</span>
								}
								@if (!MEPWorkloadCMSO && !loading) {
									<span class="info-text">{{
										"mep.components.homescreen." + (noDivision ? "noDivision" : "noWorkload") | translate
									}}</span>
								}
								@if (loading && !noDivision) {
									<mat-progress-spinner class="spinner" mode="indeterminate"></mat-progress-spinner>
								}
							</div>
							@if (!noDivision) {
								<div class="col-2">
									<app-traffic-light-mec-mep
										[selectedFamilyGroup]="selectedFamilyGroup"
										[workload]="MEPWorkloadCMSO"
									></app-traffic-light-mec-mep>
								</div>
							}
						</div>
					</div>
				</div>
				<div class="mec-card">
					<div class="mec-card-header">
						<span class="mec-card-header-text month-switch">
							<button
								type="button"
								class="month-arrow"
								[class.month-arrow-disabled]="isMonthArrowDisabled(-1)"
								[class.month-arrow-shake]="shakingArrow === 'previous'"
								[attr.aria-disabled]="isMonthArrowDisabled(-1)"
								(click)="onMonthArrowClick(-1)"
								[attr.aria-label]="'mep.components.homescreen.previousMonth' | translate"
							>
								<mat-icon>chevron_left</mat-icon>
							</button>
							<span class="month-label">
								{{ displayedMonthLabel }}
							</span>
							<button
								type="button"
								class="month-arrow"
								[class.month-arrow-disabled]="isMonthArrowDisabled(1)"
								[class.month-arrow-shake]="shakingArrow === 'next'"
								[attr.aria-disabled]="isMonthArrowDisabled(1)"
								(click)="onMonthArrowClick(1)"
								[attr.aria-label]="'mep.components.homescreen.nextMonth' | translate"
							>
								<mat-icon>chevron_right</mat-icon>
							</button>
						</span>
					</div>
					<div class="workload-container" #slideBody>
						<!-- row for mep workload expected & operative-->
						<div class="workload-information-row row">
							<div class="col-5 text-column">
								<span class="info-text">{{ "mep.components.homescreen.mepWorkload" | translate }}</span>
								<span class="description">{{ "mep.components.homescreen.expectedOperative" | translate }}</span>
							</div>
							<div [ngClass]="noDivision ? 'col-3 no-division' : 'col-1 workload-column'">
								@if (MEPWorkloadNMEO && !(loading || loadingNextMonth)) {
									<span class="info-text">{{ MEPWorkloadNMEO | number: "1.1-1" : "de" }} %</span>
								}
								@if (!MEPWorkloadNMEO && !(loading || loadingNextMonth)) {
									<span class="info-text">{{
										"mep.components.homescreen." + (noDivision ? "noDivision" : "noWorkload") | translate
									}}</span>
								}
								@if ((loading || loadingNextMonth) && !noDivision) {
									<mat-progress-spinner class="spinner" mode="indeterminate"></mat-progress-spinner>
								}
							</div>
							@if (!noDivision) {
								<div class="col-2">
									<app-traffic-light-mec-mep
										[selectedFamilyGroup]="selectedFamilyGroup"
										[workload]="MEPWorkloadNMEO"
									></app-traffic-light-mec-mep>
								</div>
							}
						</div>
						<!-- row for mep workload save & operative -->
						<div class="workload-information-row row">
							<div class="col-5 text-column">
								<span class="info-text">{{ "mep.components.homescreen.mepWorkload" | translate }}</span>
								<span class="description">{{ "mep.components.homescreen.safeOperative" | translate }}</span>
							</div>
							<div [ngClass]="noDivision ? 'col-3 no-division' : 'col-1 workload-column'">
								@if (MEPWorkloadNMSO && !(loading || loadingNextMonth)) {
									<span class="info-text">{{ MEPWorkloadNMSO | number: "1.1-1" : "de" }} %</span>
								}
								@if (!MEPWorkloadNMSO && !(loading || loadingNextMonth)) {
									<span class="info-text">{{
										"mep.components.homescreen." + (noDivision ? "noDivision" : "noWorkload") | translate
									}}</span>
								}
								@if ((loading || loadingNextMonth) && !noDivision) {
									<mat-progress-spinner class="spinner" mode="indeterminate"></mat-progress-spinner>
								}
							</div>
							@if (!noDivision) {
								<div class="col-2">
									<app-traffic-light-mec-mep
										[selectedFamilyGroup]="selectedFamilyGroup"
										[workload]="MEPWorkloadNMSO"
									></app-traffic-light-mec-mep>
								</div>
							}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="last-import-date">
		<span>{{
			lastImportDate === null
				? ("mep.components.homescreen.noImports" | translate)
				: ("mep.components.homescreen.lastImportDate" | translate) + (lastImportDate | date: "dd.MM.yyyy")
		}}</span>
	</div>
	<div class="mep-last-separator"></div>
</div>
